import moment from 'moment';

export const defaultReportTypes = [
  {
    type: 'VKYC',
    name: 'Video KYC',
    text: 'Video KYC',
    description:
      'View and download reports like verification details, agent and auditor metrics.',
    columns: [],
  },
  {
    type: 'ACCOUNT',
    name: 'Account Statement',
    description:
      'View details of all credits and debits in your Payouts account for the date range selected.',
    columns: [
      { name: 'Added On', value: 'ADDED_ON' },
      { name: 'Debit/Credit', value: 'EVENT' },
      { name: 'Particulars', value: 'EVENT_TYPE' },
      { name: 'Total Amount (INR)', value: 'TOTAL_AMOUNT' },
      { name: 'Amount (INR)', value: 'AMOUNT' },
      { name: 'Service Charge (INR)', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax (INR)', value: 'SERVICE_TAX' },
      { name: 'Closing Balance (INR)', value: 'CLOSING_BALANCE' },
      { name: 'Event Id', value: 'EVENT_ID' },
      { name: 'Remarks', value: 'REMARKS' },
    ],
  },
  {
    type: 'BANK_VALIDATION',
    name: 'Bank Validation',
    description:
      'View details of Account validations for the date range selected',
    columns: [
      { name: 'Verified At', value: 'VALIDATED_AT' },
      { name: 'User ID', value: 'USER_ID' },
      { name: 'Name', value: 'NAME' },
      { name: 'Phone', value: 'PHONE' },
      { name: 'Bank Account', value: 'BANK_ACCOUNT' },
      { name: 'Ifsc', value: 'IFSC' },
      { name: 'UPI VPA', value: 'UPI_VPA' },
      { name: 'Amount Sent', value: 'AMOUNT_DEPOSITED' },
      { name: 'Account Status', value: 'ACCOUNT_STATUS' },
      { name: 'Status Description', value: 'ACCOUNT_STATUS_CODE' },
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'UTR', value: 'UTR' },
      { name: 'Name at Bank', value: 'NAME_AT_BANK' },
      { name: 'Source', value: 'SOURCE' },
      { name: 'Reason', value: 'REASON' },
      { name: 'Event ID', value: 'EVENT_ID' },
      { name: 'Name Match Score', value: 'NAME_MATCH_SCORE' },
      { name: 'Name Match Result', value: 'NAME_MATCH_RESULT' },
      { name: 'User Name', value: 'USER_NAME' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'UPI_VALIDATION',
    name: 'UPI Validation',
    description: 'View details of UPI validations for the date range selected',
    columns: [
      { name: 'Verified At', value: 'VALIDATED_AT' },
      { name: 'Name', value: 'NAME' },
      { name: 'Phone', value: 'PHONE' },
      { name: 'IFSC', value: 'IFSC' },
      { name: 'UPI VPA', value: 'UPI_VPA' },
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'Name at Bank', value: 'NAME_AT_BANK' },
      { name: 'Source', value: 'SOURCE' },
      { name: 'Reason', value: 'REASON' },
      { name: 'Event ID', value: 'EVENT_ID' },
      { name: 'Name Match Score', value: 'NAME_MATCH_SCORE' },
      { name: 'Name Match Result', value: 'NAME_MATCH_RESULT' },
      { name: 'User Name', value: 'USER_NAME' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
      { name: 'Account Status', value: 'ACCOUNT_STATUS' },
      { name: 'Status Description', value: 'ACCOUNT_STATUS_CODE' },
    ],
  },
  {
    type: 'PAN_VERIFICATION',
    name: 'PAN Verification',
    description:
      'View details like PAN type, name of the PAN holder, verification status and more of all PAN numbers verified for the date range.',
    columns: [
      { name: 'PAN RefID', value: 'PAN_REF_ID' },
      { name: 'PAN', value: 'PAN' },
      { name: 'Name Provided', value: 'NAME_PROVIDED' },
      { name: 'Status', value: 'STATUS' },
      { name: 'PAN Type', value: 'PAN_TYPE' },
      { name: 'Name Registered', value: 'NAME_REGISTERED' },
      { name: 'Father Name', value: 'FATHER_NAME' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
      { name: 'Name Match Score', value: 'NAME_MATCH_SCORE' },
      { name: 'Name Match Result', value: 'NAME_MATCH_RESULT' },
      { name: 'Aadhaar Seeding Status', value: 'AADHAAR_SEEDING_STATUS' },
    ],
  },
  {
    type: 'OFFLINE_AADHAAR_VERIFICATION',
    name: 'Aadhaar OKYC',
    description:
      'View Details of Aadhaar Verifications(verified using OTP) for the date range selected',
    columns: [
      { name: 'Aadhaar Ref. ID', value: 'AADHAAR_REF_ID' },
      { name: 'Name', value: 'NAME' },
      { name: 'Status', value: 'STATUS' },
      { name: 'Message', value: 'MESSAGE' },
      { name: "Guardian's Name", value: 'CARE_OF' },
      { name: 'Address', value: 'ADDRESS' },
      { name: 'Date of birth', value: 'DOB' },
      { name: 'Gender', value: 'GENDER' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'GSTIN_VERIFICATION',
    name: 'GSTIN Verification',
    description:
      'View details like GSTIN, Legal name of the business, verification status and more of all GSTIN verified for the date range. View details of GSTIN verification for the date range selected',
    columns: [
      { name: 'GSTIN Ref. ID', value: 'GSTIN_REF_ID' },
      { name: 'GSTIN', value: 'GSTIN' },
      { name: 'Name of Business', value: 'NAME_OF_BUSINESS' },
      { name: 'Legal Name of Business', value: 'LEGAL_NAME_OF_BUSINESS' },
      { name: 'Centre Jurisdiction', value: 'CENTRE_JURISDICTION' },
      { name: 'State Jurisdiction', value: 'STATE_JURISDICTION' },
      { name: 'Date of Registration', value: 'DATE_OF_REGISTRATION' },
      { name: 'Constituion of Business', value: 'CONSTITUTION_OF_BUSINESS' },
      { name: 'Taxpayer Type', value: 'TAXPAYER_TYPE' },
      { name: 'GSTIN Status', value: 'GSTIN_STATUS' },
      { name: 'Cancellation Date', value: 'CANCELLATION_DATE' },
      { name: 'Principal Address', value: 'PRINCIPAL_ADDRESS' },
      { name: 'Additional Address', value: 'ADDITIONAL_ADDRESS' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
      { name: 'Status', value: 'STATUS' },
    ],
  },
  {
    type: 'IFSC_VERIFICATION',
    name: 'IFSC Verification',
    description:
      'View details like Bank Name, Branch name, Address, City and Supported Modes, verification status and more of all IFSC numbers verified for the date range selected',
    columns: [
      { name: 'IFSC', value: 'IFSC' },
      { name: 'Bank Name', value: 'BANK_NAME' },
      { name: 'Branch Name', value: 'BRANCH_NAME' },
      { name: 'Status', value: 'STATUS' },
      { name: 'IMPS', value: 'IMPS' },
      { name: 'NEFT', value: 'NEFT' },
      { name: 'RTGS', value: 'RTGS' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'REVERSE_PENNY_DROP',
    name: 'BAV - Reverse Penny Drop',
    description:
      'View details like Name, Name At Bank, reverse penny status and more of all Bank Account number verified through Reverse Penny Drop for the date range selected',
    columns: [
      { name: 'Verification Id', value: 'VERIFICATION_ID' },
      { name: 'Request Id', value: 'REQUEST_ID' },
      { name: 'IFSC', value: 'IFSC' },
      { name: 'Bank Account', value: 'BANK_ACCOUNT' },
      { name: 'VPA', value: 'VPA' },
      { name: 'Name At Bank', value: 'NAME_AT_BANK' },
      { name: 'UTR', value: 'UTR' },
      { name: 'Status', value: 'STATUS' },
      { name: 'Reversal Status', value: 'REVERSAL_STATUS' },
      { name: 'Link Valid Upto', value: 'LINK_VALID_UPTO' },
      { name: 'Name Match Score', value: 'NAME_MATCH_SCORE' },
      { name: 'Name Match Result', value: 'NAME_MATCH_RESULT' },
      { name: 'Penny Collected On', value: 'PENNY_COLLECTED_ON' },
      { name: 'Added On', value: 'ADDED_ON' },
      { name: 'Processed On', value: 'PROCESSED_ON' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'PAN_360_VERIFICATION',
    name: 'PAN 360 Verification',
    description: 'View details of PAN 360 for the date range selected',
    columns: [
      { name: 'Status', value: 'STATUS' },
      { name: 'Pan Ref ID', value: 'PAN_REF_ID' },
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'Name Provided', value: 'NAME_PROVIDED' },
      { name: 'Pan', value: 'PAN' },
      { name: 'Name Registered', value: 'NAME_REGISTERED' },
      { name: 'Name Pan Card', value: 'NAME_PAN_CARD' },
      { name: 'Pan Type', value: 'PAN_TYPE' },
      { name: 'Gender', value: 'GENDER' },
      { name: 'DOB', value: 'DOB' },
      { name: 'Masked Aadhaar', value: 'MASKED_AADHAAR' },
      { name: 'Email', value: 'EMAIL' },
      { name: 'Mobile Number', value: 'MOBILE_NUMBER' },
      { name: 'Aadhaar Linked', value: 'AADHAAR_LINKED' },
      { name: 'Address', value: 'ADDRESS' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'PAN_LITE_VERIFICATION',
    name: 'PAN Lite Verification',
    description: 'View details of PAN Lite for the date range selected',
    columns: [
      { name: 'Status', value: 'STATUS' },
      { name: 'Pan Ref ID', value: 'PAN_REF_ID' },
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'Name Provided', value: 'NAME_PROVIDED' },
      { name: 'Pan', value: 'PAN' },
      { name: 'DOB', value: 'DOB' },
      { name: 'Name Match Result', value: 'NAME_MATCH_RESULT' },
      { name: 'DOB Match Result', value: 'DOB_MATCH_RESULT' },
      { name: 'Pan Status', value: 'PAN_STATUS' },
      { name: 'Aadhaar Seeding Status', value: 'AADHAAR_SEEDING_STATUS' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'VEHICLE_RC_REPORT',
    name: 'Vehicle RC Verification',
    description: 'View details of Vehicle RC for the date range selected',
    columns: [
      { name: 'Verification Id', value: 'VERIFICATION_ID' },
      { name: 'Reference Id', value: 'REFERENCE_ID' },
      { name: 'Status', value: 'STATUS' },
      { name: 'Reg No', value: 'REG_NO' },
      { name: 'Class', value: 'CLASS' },
      { name: 'Chassis', value: 'CHASSIS' },
      { name: 'Engine', value: 'ENGINE' },
      { name: 'Vehicle Manufacturer Name', value: 'VEHICLE_MANUFACTURER_NAME' },
      { name: 'Model', value: 'MODEL' },
      { name: 'Vehicle Colour', value: 'VEHICLE_COLOUR' },
      { name: 'Type', value: 'TYPE' },
      { name: 'Norms Type', value: 'NORMS_TYPE' },
      { name: 'Body Type', value: 'BODY_TYPE' },
      { name: 'Owner Count', value: 'OWNER_COUNT' },
      { name: 'Owner', value: 'OWNER' },
      { name: 'Owner Father Name', value: 'OWNER_FATHER_NAME' },
      { name: 'Mobile Number', value: 'MOBILE_NUMBER' },
      { name: 'Rc Status', value: 'RC_STATUS' },
      { name: 'Status As On', value: 'STATUS_AS_ON' },
      { name: 'Reg Authority', value: 'REG_AUTHORITY' },
      { name: 'Reg Date', value: 'REG_DATE' },
      { name: 'Rc Financer', value: 'RC_FINANCER' },
      { name: 'Present Address', value: 'PRESENT_ADDRESS' },
      { name: 'Split Present Address', value: 'SPLIT_PRESENT_ADDRESS' },
      { name: 'Permanent Address', value: 'PERMANENT_ADDRESS' },
      { name: 'Split Permanent Address', value: 'SPLIT_PERMANENT_ADDRESS' },
      { name: 'Vehicle Cubic Capacity', value: 'VEHICLE_CUBIC_CAPACITY' },
      { name: 'Gross Vehicle Weight', value: 'GROSS_VEHICLE_WEIGHT' },
      { name: 'Unladen Weight', value: 'UNLADEN_WEIGHT' },
      { name: 'Vehicle Category', value: 'VEHICLE_CATEGORY' },
      { name: 'Rc Standard Cap', value: 'RC_STANDARD_CAP' },
      { name: 'Vehicle Cylinders No', value: 'VEHICLE_CYLINDERS_NO' },
      { name: 'Vehicle Seat Capacity', value: 'VEHICLE_SEAT_CAPACITY' },
      { name: 'Vehicle Sleeper Capacity', value: 'VEHICLE_SLEEPER_CAPACITY' },
      { name: 'Vehicle Standing Capacity', value: 'VEHICLE_STANDING_CAPACITY' },
      { name: 'Wheelbase', value: 'WHEELBASE' },
      { name: 'Vehicle Number', value: 'VEHICLE_NUMBER' },
      { name: 'Pucc Number', value: 'PUCC_NUMBER' },
      { name: 'Pucc Upto', value: 'PUCC_UPTO' },
      { name: 'Blacklist Status', value: 'BLACKLIST_STATUS' },
      { name: 'Blacklist Details', value: 'BLACKLIST_DETAILS' },
      { name: 'Challan Details', value: 'CHALLAN_DETAILS' },
      { name: 'Permit Issue Date', value: 'PERMIT_ISSUE_DATE' },
      { name: 'Permit Number', value: 'PERMIT_NUMBER' },
      { name: 'Permit Type', value: 'PERMIT_TYPE' },
      { name: 'Permit Valid From', value: 'PERMIT_VALID_FROM' },
      { name: 'Permit Valid Upto', value: 'PERMIT_VALID_UPTO' },
      { name: 'Non Use Status', value: 'NON_USE_STATUS' },
      { name: 'Non Use From', value: 'NON_USE_FROM' },
      { name: 'Non Use To', value: 'NON_USE_TO' },
      { name: 'National Permit Number', value: 'NATIONAL_PERMIT_NUMBER' },
      { name: 'National Permit Upto', value: 'NATIONAL_PERMIT_UPTO' },
      { name: 'National Permit Issued By', value: 'NATIONAL_PERMIT_ISSUED_BY' },
      { name: 'Is Commercial', value: 'IS_COMMERCIAL' },
      { name: 'Noc Details', value: 'NOC_DETAILS' },
      { name: 'GSTIN List', value: 'GSTIN_LIST' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
      { name: 'Rc Expiry Date', value: 'RC_EXPIRY_DATE' },
      { name: 'Vehicle Tax Upto', value: 'VEHICLE_TAX_UPTO' },
      {
        name: 'Vehicle Manufacturing Month Year',
        value: 'VEHICLE_MANUFACTURING_MONTH_YEAR',
      },
      {
        name: 'Vehicle Insurance Company Name',
        value: 'VEHICLE_INSURANCE_COMPANY_NAME',
      },
      { name: 'Vehicle Insurance Upto', value: 'VEHICLE_INSURANCE_UPTO' },
      {
        name: 'Vehicle Insurance Policy Number',
        value: 'VEHICLE_INSURANCE_POLICY_NUMBER',
      },
      { name: 'Source', value: 'SOURCE' },
    ],
  },
  {
    type: 'DRIVING_LICENSE_REPORT',
    name: 'Driving License Verification',
    description: 'View details of Driving License for the date range selected',
    columns: [
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'Reference ID', value: 'REFERENCE_ID' },
      { name: 'Status', value: 'STATUS' },
      { name: 'DL Number', value: 'DL_NUMBER' },
      { name: 'Badge Issue Date', value: 'BADGE_ISSUE_DATE' },
      { name: 'Badge No', value: 'BADGE_NO' },
      { name: 'Class of Vehicle', value: 'CLASS_OF_VEHICLE' },
      { name: 'Date of Issue', value: 'DATE_OF_ISSUE' },
      { name: 'Date of Last Transaction', value: 'DATE_OF_LAST_TRANSACTION' },
      { name: 'DL Status', value: 'DL_STATUS' },
      { name: 'Last Transacted At', value: 'LAST_TRANSACTED_AT' },
      { name: 'DL Name', value: 'DL_NAME' },
      { name: 'Father or Husband Name', value: 'FATHER_OR_HUSBAND_NAME' },
      { name: 'Address', value: 'ADDRESS' },
      { name: 'DL Validity', value: 'DL_VALIDITY' },
      { name: 'Address List', value: 'ADDRESS_LIST' },
      { name: 'Split Address', value: 'SPLIT_ADDRESS' },
      { name: 'Source', value: 'SOURCE' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'PASSPORT_REPORT',
    name: 'Passport Verification',
    description: 'View details of Passport for the date range selected',
    columns: [
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'Reference ID', value: 'REFERENCE_ID' },
      { name: 'Status', value: 'STATUS' },
      { name: 'File Number', value: 'FILE_NUMBER' },
      { name: 'Passport Name', value: 'PASSPORT_NAME' },
      { name: 'DOB', value: 'DOB' },
      { name: 'Application Type', value: 'APPLICATION_TYPE' },
      { name: 'Application Received Date', value: 'APPLICATION_RECEIVED_DATE' },
      { name: 'Source', value: 'SOURCE' },
      { name: 'Verified At', value: 'VERIFIED_AT' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  // {
  //   type: 'AADHAAR_OCR_VERIFICATION',
  //   name: 'Aadhaar OCR Verification',
  //   description: 'View details of Aadhaar OCR for the date range selected',
  //   columns: [
  //     { name: 'Status', value: 'STATUS' },
  //     { name: 'Verification ID', value: 'VERIFICATION_ID' },
  //     { name: 'Message', value: 'MESSAGE' },
  //     { name: 'Reference ID', value: 'REFERENCEID' },
  //     { name: 'Service Charge', value: 'SERVICE_CHARGE' },
  //     { name: 'Service Tax', value: 'SERVICE_TAX' },
  //     { name: 'UID', value: 'UID' },
  //     { name: 'Name', value: 'NAME' },
  //     { name: 'YOB', value: 'YOB' },
  //     { name: 'Pincode', value: 'PINCODE' },
  //     { name: 'Address', value: 'ADDRESS' },
  //     { name: 'State', value: 'STATE' },
  //     { name: 'Gender', value: 'GENDER' },
  //     { name: 'Father', value: 'FATHER' },
  //     { name: 'Vaild', value: 'VALID' },
  //     { name: 'Verified At', value: 'VERIFIED_AT' },
  //   ],
  // },
  // {
  //   type: 'PAN_OCR_VERIFICATION',
  //   name: 'PAN OCR Verification',
  //   description: 'View details of PAN OCR for the date range selected',
  //   columns: [
  //     { name: 'Status', value: 'STATUS' },
  //     { name: 'Verification ID', value: 'VERIFICATION_ID' },
  //     { name: 'Message', value: 'MESSAGE' },
  //     { name: 'Reference ID', value: 'REFERENCEID' },
  //     { name: 'Service Charge', value: 'SERVICE_CHARGE' },
  //     { name: 'Service Tax', value: 'SERVICE_TAX' },
  //     { name: 'Age', value: 'AGE' },
  //     { name: 'Name', value: 'NAME' },
  //     { name: 'Father', value: 'FATHER' },
  //     { name: 'Valid', value: 'VALID' },
  //     { name: 'DOB', value: 'DOB' },
  //     { name: 'Pan Type', value: 'PANTYPE' },
  //     { name: 'Pan', value: 'PAN' },
  //     { name: 'Verified At', value: 'VERIFIED_AT' },
  //   ],
  // },
  // {
  //   type: 'UPI_FROM_MOBILE_NUMBER',
  //   name: 'UPI Validation - Mobile Number',
  //   description:
  //     'View details like Name, Name At Bank, verification status and more of all VPA with mobile numbers verified for the date range selected',
  //   columns: [
  //     { name: 'Verification Id', value: 'VERIFICATION_ID' },
  //     { name: 'Request Id', value: 'REQUEST_ID' },
  //     { name: 'Name', value: 'NAME' },
  //     { name: 'Mobile Number', value: 'MOBILE_NUMBER' },
  //     { name: 'VPA', value: 'VPA' },
  //     { name: 'Name At Bank', value: 'NAME_AT_BANK' },
  //     { name: 'Status', value: 'STATUS' },
  //     { name: 'Added On', value: 'ADDED_ON' },
  //     { name: 'Processed On', value: 'PROCESSED_ON' },
  //     { name: 'Service Charge', value: 'SERVICE_CHARGE' },
  //     { name: 'Service Tax', value: 'SERVICE_TAX' },
  //   ],
  // },
];

export const REFRESH_INTERVAL = 10000;

export const LABEL_BY_TYPE = {
  ACCOUNT: 'Account Statement',
  REVERSED_TRANSFER: 'Reversed Transfers',
  BANK_VALIDATION: 'Bank Validation',
  PAN_VERIFICATION: 'PAN Verification',
  AADHAAR_VERIFICATION: 'Aadhaar Verification',
  GSTIN_VERIFICATION: 'GSTIN Verification',
  OFFLINE_AADHAAR_VERIFICATION: 'Aadhaar OKYC',
  IFSC_VERIFICATION: 'IFSC Verification',
  REVERSE_PENNY_DROP: 'Bank Account Verification - Reverse Penny Drop',
  UPI_VALIDATION: 'UPI  Validation',
  OCR_VERIFICATION: 'OCR Verification',
  PAN_360_VERIFICATION: 'PAN 360 Verification',
  PAN_LITE_VERIFICATION: 'PAN Lite Verification',
  VEHICLE_RC_REPORT: 'Vehicle RC Verification',
  DRIVING_LICENSE_REPORT: 'Driving License Verification',
  PASSPORT_REPORT: 'Passport Verification',
  // UPI_FROM_MOBILE_NUMBER: 'UPI Validation - Mobile Number',
  // AADHAAR_OCR_VERIFICATION: 'Aadhaar OCR Verification',
  // PAN_OCR_VERIFICATION: 'PAN OCR Verification',
};

export const REQUIRED_FIELDS = ['reportName'];

export const FILE_EXTENSIONS = {
  CSV: 'CSV',
  XLSX: 'XLSX',
};

export const VKYC_REPORTS = [
  {
    type: 'KYC_SESSION_REPORT',
    name: 'KYC Session Report',
    description:
      'View details like Name, Name At Bank, verification status and more of all VPA with mobile numbers verified for the date range selected',
    columns: [
      { name: 'Session ID', value: 'SESSION_ID' },
      { name: 'Verification ID', value: 'VERIFICATION_ID' },
      { name: 'User Phone Number', value: 'USER_PHONE_NUMBER' },
      { name: 'User Name', value: 'USER_NAME' },
      { name: 'User ID', value: 'USER_ID' },
      { name: 'KYC Status', value: 'KYC_STATUS' },
      { name: 'Session Start', value: 'SESSION_START' },
      { name: 'Session Duration', value: 'SESSION_DURATION' },
      { name: 'Agent Name', value: 'AGENT_NAME' },
      { name: 'Auditor Name', value: 'AUDITOR_NAME' },
      {
        name: 'Agent Verification Outcome',
        value: 'AGENT_VERIFICATION_OUTCOME',
      },
      {
        name: 'Auditor Verification Outcome',
        value: 'AUDITOR_VERIFICATION_OUTCOME',
      },
      { name: 'Agent Failure Reason', value: 'AGENT_FAILURE_REASON' },
      { name: 'Auditor Failure Reason', value: 'AUDITOR_FAILURE_REASON' },
      { name: 'Recording Link', value: 'RECORDING_LINK' },
      { name: 'Call Type', value: 'CALL_TYPE' },
      { name: 'Scheduled Call Time', value: 'SECHEDULED_CALL_TIME' },
      { name: 'Agent ID', value: 'AGENT_ID' },
      { name: 'Auditor ID', value: 'AUDITOR_ID' },
      { name: 'Service Charge', value: 'SERVICE_CHARGE' },
      { name: 'Service Tax', value: 'SERVICE_TAX' },
    ],
  },
  {
    type: 'AGENT_PERFORMANCE_REPORT',
    name: 'Agent Performance Report',
    description:
      'View details like Name, Name At Bank, verification status and more of all VPA with mobile numbers verified for the date range selected',
    columns: [
      { name: 'Agent ID', value: 'AGENT_ID' },
      { name: 'Total Sessions Handled', value: 'TOTAL_SESSIONS_HANDLED' },
      { name: 'Average Handling Time', value: 'AVERAGE_HANDLING_TIME' },
      { name: 'Max Time Taken', value: 'MAX_TIME_TAKEN' },
      { name: 'Approval Rate', value: 'APPROVAL_RATE' },
      { name: 'Rejection Rate', value: 'REJECTION_RATE' },
      { name: 'Unable to Verify Rate', value: 'UNABLE_TO_VERIFY_RATE' },
      { name: '% Approval Accuracy', value: 'APPROVAL_ACCURACY' },
      { name: 'End User Drop-offs During Call', value: 'END_USER_DROPOFFS' },
      { name: 'Fraud Detected', value: 'FRAUD_DETECTED' },
      { name: 'User Feedback Rating', value: 'USER_FEEDBACK_RATING' },
      { name: 'Agent Drop-offs', value: 'AGENT_DROPOFFS' },
    ],
  },
  // {
  //   type: 'COMPLIANCE_AUDIT_REPORT',
  //   name: 'Compliance audit report',
  //   description:
  //     'View details like Name, Name At Bank, verification status and more of all VPA with mobile numbers verified for the date range selected',
  //   columns: [
  //     { name: 'Verification Id', value: 'VERIFICATION_ID' },
  //     { name: 'Request Id', value: 'REQUEST_ID' },
  //     { name: 'Name', value: 'NAME' },
  //     { name: 'Mobile Number', value: 'MOBILE_NUMBER' },
  //     { name: 'VPA', value: 'VPA' },
  //     { name: 'Name At Bank', value: 'NAME_AT_BANK' },
  //     { name: 'Status', value: 'STATUS' },
  //     { name: 'Added On', value: 'ADDED_ON' },
  //     { name: 'Processed On', value: 'PROCESSED_ON' },
  //     { name: 'Service Charge', value: 'SERVICE_CHARGE' },
  //     { name: 'Service Tax', value: 'SERVICE_TAX' },
  //   ],
  // },
];

export const VALID_REPORT_TYPES = [
  'ACCOUNT',
  'BANK_VALIDATION',
  'PAN_VERIFICATION',
  'AADHAAR_VERIFICATION',
  'GSTIN_VERIFICATION',
  'OFFLINE_AADHAAR_VERIFICATION',
  'IFSC_VERIFICATION',
  // 'UPI_FROM_MOBILE_NUMBER',
  'REVERSE_PENNY_DROP',
  'UPI_VALIDATION',
  'AADHAAR_OCR_VERIFICATION',
  'PAN_OCR_VERIFICATION',
  'PAN_360_VERIFICATION',
  'PAN_LITE_VERIFICATION',
  'VEHICLE_RC_REPORT',
  'DRIVING_LICENSE_REPORT',
  'PASSPORT_REPORT',
];

export const ACTION_TYPES = {
  DOWNLOAD: 'DOWNLOAD',
  DELETE: 'DELETE',
};

export const CURRENT_DATE = moment().format('DD-MM-YYYY');

export const MODAL_TYPES = {
  GENERATE: 'GENERATE',
  DELETE: 'DELETE',
  GENERATE_REPORT: 'GENERATE_REPORT',
};
